import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { INotificationApiListResponse, INotificationMutationResponse, INotificationUpdateParams } from '@/types/notification';

export const notificationList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<INotificationApiListResponse>> => {
    return axios.get('/api/notification/list', { ...config, params });
};

export const notificationCreate = (params: INotificationUpdateParams, config?: AxiosRequestConfig): Promise<AxiosResponse<INotificationMutationResponse>> => {
    return axios.post('/api/notification/create', params, config);
};

export const notificationUpdate = (params: INotificationUpdateParams, config?: AxiosRequestConfig): Promise<AxiosResponse<INotificationMutationResponse>> => {
    return axios.post('/api/notification/update', params, config);
};

export const notificationDelete = (params: INotificationUpdateParams, config?: AxiosRequestConfig): Promise<AxiosResponse<INotificationMutationResponse>> => {
    return axios.post('/api/notification/delete', params, config);
};
